<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <div class="top">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick1">
          <el-tab-pane label="企业概览"
                       name="first">
            <EnterpriseOverview></EnterpriseOverview>
          </el-tab-pane>
          <el-tab-pane label="企业档案"
                       name="second">
            <archives></archives>
          </el-tab-pane>
          <el-tab-pane label="组织架构"
                       name="third">
            <div>组织架构</div>
          </el-tab-pane>
          <el-tab-pane label="变更记录"
                       name="fourth">
            <ChangeRecord>1</ChangeRecord>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>

<script>
import EnterpriseOverview from './enterprise-overview'
import ChangeRecord from './change-record'
import archives from './archives'

export default {
  data () {
    return {
      dataForm: {
        creatorName: ''
      },
      activeName: 'first'
    }
  },
  methods: {
    handleClick1 (tab) {
    }
  },
  components: {
    EnterpriseOverview,
    ChangeRecord,
    archives
  }
}
</script>
